import { useState } from 'react';
import { Button, Drawer, Group, Radio, Indicator } from '@mantine/core';
import { FiFilter } from 'react-icons/fi';
import { ContactStatus } from '../types';

const statusOptions = [
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' },
    { value: 'DELETED', label: 'Deleted' },
    { value: 'ARCHIVED', label: 'Archived' },
];

interface FilterRecordsButtonProps {
    onFilterChange: (status: ContactStatus | null) => void;
    defaultStatus?: ContactStatus | null;
}

export const FilterRecordsButton = ({ onFilterChange, defaultStatus = null }: FilterRecordsButtonProps) => {
    const [opened, setOpened] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState<ContactStatus | null>(defaultStatus);
    const [appliedFilter, setAppliedFilter] = useState<ContactStatus | null>(defaultStatus);

    const handleApply = () => {
        onFilterChange(selectedStatus);
        setAppliedFilter(selectedStatus);
        setOpened(false);
    };

    const handleClear = () => {
        setSelectedStatus(null);
        onFilterChange(null);
        setAppliedFilter(null);
        setOpened(false);
    };

    return (
        <>
            <Indicator disabled={!appliedFilter} size={12} color="red">
                <Button
                    variant="outline"
                    leftSection={<FiFilter size={16} />}
                    onClick={() => setOpened(true)}
                >
                    Filter
                </Button>
            </Indicator>

            <Drawer
                opened={opened}
                onClose={() => setOpened(false)}
                title="Filter Contacts"
                position="right"
                size="sm"
            >
                <Radio.Group
                    label="Status"
                    value={selectedStatus || ''}
                    onChange={(value) => setSelectedStatus(value as ContactStatus || null)}
                >
                    <Group mt="xs" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                        <Radio value="" label="All" />
                        {statusOptions.map((option) => (
                            <Radio key={option.value} value={option.value} label={option.label} />
                        ))}
                    </Group>
                </Radio.Group>

                <Group justify="flex-end" mt="md" gap="xs">
                    <Button variant="outline" color="red" onClick={handleClear}>
                        Clear
                    </Button>
                    <Button onClick={handleApply}>
                        Apply
                    </Button>
                </Group>
            </Drawer>
        </>
    );
};
